import { render } from "./WCProductRow.vue?vue&type=template&id=3053211b&scoped=true"
import script from "./WCProductRow.vue?vue&type=script&lang=js"
export * from "./WCProductRow.vue?vue&type=script&lang=js"

import "./WCProductRow.vue?vue&type=style&index=0&id=3053211b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3053211b"]])

export default __exports__